import { XStack, Text } from "tamagui";
import { useFormContext } from "react-hook-form";
import { colors } from "@styles/colors";

export default function FormQuantity({ fontSize = 22 }: { fontSize?: number }) {
  const {
    setValue,
    watch,
    formState: { errors },
  } = useFormContext();
  const currentQuantity = watch("qty");
  return (
    <XStack alignItems="center">
      <Text fontWeight="bold">數量</Text>
      <XStack alignItems="center">
        <Text
          onPress={() => setValue("qty", Math.max(1, currentQuantity - 1), { shouldValidate: true })}
          className="px-3 py-1 text-[20px] text-[#64748B] cursor-pointer hover:opacity-70">
          −
        </Text>
        <Text padding={8} fontSize={fontSize} color={colors.primary} fontWeight="bold">
          {currentQuantity}
        </Text>
        <Text
          onPress={() => setValue("qty", Math.min(20, currentQuantity + 1), { shouldValidate: true })}
          className="px-3 py-1 text-[20px] text-primary cursor-pointer hover:opacity-70">
          +
        </Text>
      </XStack>
    </XStack>
  );
}
